module.exports = __webpack_public_path__ + "static/media/IMG-5660.3c946b28.jpg";